module.exports = __webpack_public_path__ + "static/media/reports.e418925f.svg";